// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBox_wrapper__0HLUr"};